import {AsyncPage, Empty} from 'Core/models/Async';
import {Page} from 'Core/models/Page';
import {createAction} from 'Shared/utilities/actionCreator';
import { InvoiceDiscrepancyDto } from '../models/Invoice';

export const enum InvoiceDiscrepanciesActionType {
  GET_INVOICE_DISCREPANCIES = 'account/GET_INVOICE_DISCREPANCIES',
  CHANGE_INVOICE_DISCREPANCIES = 'account/CHANGE_INVOICE_DISCREPANCIES',
}

export const getInvoiceDiscrepancies = (accountNumber: string, invoiceLink: string, page?: Page<InvoiceDiscrepancyDto>) =>
  createAction(InvoiceDiscrepanciesActionType.GET_INVOICE_DISCREPANCIES, {accountNumber, invoiceLink, page});
export const changeInvoiceDiscrepancies = (discrepancies: AsyncPage<Page<InvoiceDiscrepancyDto>>) =>
  createAction(InvoiceDiscrepanciesActionType.CHANGE_INVOICE_DISCREPANCIES, {discrepancies});

type InvoiceDiscrepanciesState = {
  invoiceDiscrepancies: AsyncPage<Page<InvoiceDiscrepancyDto>>;
};

export const DEFAULT_STATE: InvoiceDiscrepanciesState = {
  invoiceDiscrepancies: new Empty(),
};

type InvoiceDiscrepancyAction =
  | ReturnType<typeof getInvoiceDiscrepancies>
  | ReturnType<typeof changeInvoiceDiscrepancies>;

export default (
  state: InvoiceDiscrepanciesState = DEFAULT_STATE,
  action: InvoiceDiscrepancyAction
): InvoiceDiscrepanciesState => {
  if (action.type === InvoiceDiscrepanciesActionType.CHANGE_INVOICE_DISCREPANCIES) {
    return {
      ...state,
      invoiceDiscrepancies: action.payload.discrepancies,
    };
  }
  return state;
};
